'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getGameCategory(gameCategories = [], defaultCategories = []) {
  if (defaultCategories.length < 1 && gameCategories.length < 1) {
    throw new Error("there must be at least one category slug in any of the two arguments");
  }
  const filteredCats = gameCategories.filter((cat) => !defaultCategories.includes(cat));
  if (filteredCats.length) {
    return filteredCats[0];
  }
  return defaultCategories[0];
}

exports.getGameCategory = getGameCategory;
